import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { Locale } from "@/Common/Models/Localization/Locale";
import { Button, LinkButton } from "@/DesignSystem";

import styles from "./AIScribe.module.scss";

import englishImageSource from "@/Globals/_images/ai-scribe-marketing-en.png";
import frenchImageSource from "@/Globals/_images/ai-scribe-marketing-fr.png";

interface IAIScribeMarketingPopupProps {
    onRemindMeLater: () => void;
    onCreateAccount: () => void;
    onLinkAccount: () => void;
    onClose: () => void;
}

function AIScribeMarketingPopup({ onRemindMeLater, onCreateAccount, onLinkAccount, onClose }: Readonly<IAIScribeMarketingPopupProps>): JSX.Element {
    const { getText } = useTranslation();

    const isLocaleFrench = sessionStore.locale === Locale.fr;

    const renderFooter = (): JSX.Element => (
        <div className={styles.footer}>
            <Button
                id="ai-scribe-marketing-popup-remind-me-later"
                dataCy="ai-scribe-marketing-popup-remind-me-later"
                category="secondary"
                variant="neutral"
                label={getText("AIScribe_MarketingPopup_RemindMeLater")}
                onClick={onRemindMeLater}
            />
            <Button
                id="ai-scribe-marketing-popup-create-account"
                dataCy="ai-scribe-marketing-popup-create-account"
                category="secondary"
                variant="brand"
                label={getText("AIScribe_MarketingPopup_CreateCarewayAccount")}
                onClick={onCreateAccount}
            />
            <Button
                id="ai-scribe-marketing-popup-link-account"
                dataCy="ai-scribe-marketing-popup-link-account"
                category="primary"
                variant="brand"
                label={getText("AIScribe_MarketingPopup_LinkCarewayAccount")}
                onClick={onLinkAccount}
            />
        </div>
    );

    return (
        <Modal
            fixedOverlayPosition
            showOverlay
            showX
            disableOverlayClose
            roundTopCorner
            width={875}
            title={getText("AIScribe_MarketingPopup_Title")}
            onClose={onClose}
            id="ai-scribe-marketing-popup"
            dataCy="ai-scribe-marketing-popup"
            footer={renderFooter()}
            cssClass={styles.aiScribeMarketingPopup}
            bodyStyle={{ padding: 0 }}
            draggable
        >
            <div className={styles.body}>
                <div className={styles.content}>
                    <p className={styles.header}>
                        {getText("AIScribe_MarketingPopup_Header")}
                    </p>
                    <p className={styles.description}>
                        {getText("AIScribe_MarketingPopup_Message1")}
                    </p>
                    <p className={styles.description2}>
                        {getText("AIScribe_MarketingPopup_Message2")}
                    </p>
                    <div>
                        <LinkButton
                            dataCy="ai-scribe-marketing-popup-link-message"
                            label={getText("AIScribe_MarketingPopup_LinkMessage")}
                            onClick={() => window.open(`https://medfar.my.site.com/s/article/Utiliser-assistant-IA-dans-MYLE?language=${isLocaleFrench ? "fr" : "en_US"}`, "_blank", "noopener")}
                        />
                    </div>
                </div>
                <div className={styles.imageContainer}>
                    <img
                        src={isLocaleFrench ? frenchImageSource : englishImageSource}
                        alt="AI Scribe Marketing"
                    />
                </div>
            </div>
        </Modal>
    );
}

export { AIScribeMarketingPopup };
